import { api } from '@bit/duncank.work.api';
// import apiErrors from '@bit/duncank.work.utils.api-errorhandling';

export default {
    namespaced: true,
    state: {
        products: {
            pagination: {
                count: 50,
                start: 0,
                start_filtered: 0,
                atBottom: false,
                atBottom_filtered: false,
            },
            items: [],
            items_filtered: [],
            isFiltered: false,
        },
        cart: {
            items: [],
        },
        mode: 'products',
        filters: {
            categories: [],
            price: [0, 10000],
            search: '',
            size: [],
        },
        searchSuggestions: [],
        defaultPrices: [0, 10000],
        categories: [],
        sizes: [],
        checkout: {
            client: {
                name: '',
                email: '',
                organization: '',
                address: {},
                address_string: '',
                phone: '',
            },
            contact: {
                name: '',
                email: '',
                phone: '',
            },
            name: '',
            remarks: '',
            delivery: {
                type: 'Ophalen',
                address: {},
                date: undefined,
            },
        },
    },
    getters: {
        // Filters
        filters: state => state.filters,

        defaultPrices: state => state.defaultPrices,

        sizes: state => state.sizes,

        categories: state => state.categories,

        searchSuggestions: state => state.searchSuggestions,

        // Products
        products: state => (mode) => {
            if (mode === 'products') {
                if (state.products.isFiltered) {
                    return state.products.items_filtered || [];
                }
                return state.products.items || [];
            }
            if (mode === 'cart') {
                return state.cart.items;
            }
            return [];
        },

        product: state => (ids) => {
            if (typeof ids === 'number') {
                return state.products.items.find(it => it.id === ids) || false;
            }
            if (Array.isArray(ids)) {
                return state.products.items.filter(it => ids.includes(it.id)) || [];
            }
            return [];
        },

        pagination: state => (filtered) => {
            const keySuffix = (filtered || (filtered !== false && state.products.isFiltered)) ? '_filtered' : '';
            return {
                count: state.products.pagination.count,
                start: state.products.pagination[`start${keySuffix}`],
            };
        },

        // Cart
        cart: state => state.cart.items || [],

        // eslint-disable-next-line
        cartQty: (state) => {
            if (!state.cart.items || state.cart.items.length < 1) {
                return { amount: 0, price: 0 };
            }
            return state.cart.items.reduce((total, item) => {
                total.amount += +item.amount;
                if (item.product.price && item.product.price.sale_price) {
                    total.price += item.amount * item.product.price.sale_price;
                }
                return total;
            }, { amount: 0, price: 0 });
        },

        checkout: state => state.checkout,
    },
    mutations: {
        storeProducts(state, { items = [], filtered = false }) {
            const keySuffix = filtered ? '_filtered' : '';
            const oppositeKeySuffix = !filtered ? '_filtered' : '';

            state.products.isFiltered = filtered;
            if (!filtered) {
                state.products.items_filtered = [];
            }
            state.products.pagination[`start${oppositeKeySuffix}`] = 0;
            state.products.pagination[`atBottom${oppositeKeySuffix}`] = false;

            if (state.products.pagination[`start${keySuffix}`] > 0) {
                if (items.length < state.products.pagination.count) {
                    state.products.pagination[`atBottom${keySuffix}`] = true;
                }
                state.products[`items${keySuffix}`] = state.products[`items${keySuffix}`].concat(items);
            } else {
                state.products[`items${keySuffix}`] = items;
            }
        },

        bumpStart(state) {
            const keySuffix = state.products.isFiltered ? '_filtered' : '';
            state.products.pagination[`start${keySuffix}`] += state.products.pagination.count;
        },

        stopFiltering(state) {
            state.products.isFiltered = false;
            state.products.pagination.start_filtered = 0;
            state.products.pagination.atBottom_filtered = false;
        },

        resetPagination(state) {
            state.products.pagination.start_filtered = 0;
            state.products.pagination.atBottom_filtered = false;
            state.products.pagination.start = 0;
            state.products.pagination.atBottom = false;
        },

        storeFilters(state, data) {
            // Pricerange
            const priceDefaults = [0, 10000];
            const priceFilterData = data.find(it => it.naam === 'prijs');
            if (priceFilterData) {
                priceDefaults[0] = priceFilterData.min;
                priceDefaults[1] = priceFilterData.max;
            }
            state.filters.price = priceDefaults;
            state.defaultPrices = priceDefaults;

            // Potsize
            let potsizes = [];
            const potsizeFilterData = data.find(it => it.naam === 'potmaat');
            if (potsizeFilterData) {
                potsizes = potsizeFilterData.options;
            }
            state.sizes = potsizes;

            // Categories
            const categories = data.find(it => it.naam === 'categorie');
            if (categories) {
                state.categories = categories.options;
            }

            // Suggestions
            const suggs = data.find(it => it.naam === 'suggesties');
            if (suggs) {
                state.searchSuggestions = suggs.options.sort((a, b) => ((a < b) ? -1 : 0));
            }
        },

        updateCart(state, { product, amount }) {
            const inCart = state.cart.items.findIndex(it => it.product.id === product.id);
            if (inCart > -1) { // product is already in cart, update
                if (amount === 0) {
                    state.cart.items.splice(inCart, 1);
                } else {
                    state.cart.items[inCart].amount = amount;
                }
            } else { // add product to cart
                state.cart.items.push({ product, amount });
            }
            localStorage.setItem('cart', JSON.stringify(state.cart));
        },

        clearCart(state) {
            state.cart.items = [];
            localStorage.removeItem('cart');
        },

        restoreCart(state, data) {
            state.cart = data;
            localStorage.setItem('cart', JSON.stringify(data));
        },

        setUserAddress(state, user) {
            state.checkout.client.address_string = `${user.address}, ${user.zipcode} ${user.city}, ${user.country}`;
        },

        setUserInfo(state, { email, name, phone }) {
            state.checkout.contact.name = name;
            state.checkout.contact.email = email;
            state.checkout.contact.phone = phone;
        },
    },
    actions: {

        setUserInfo({ commit }, { user = {} } = {}) {
            if (user.address) {
                commit('setUserAddress', user);
            }
            if (user.contact_name && user.contact_email) {
                commit('setUserInfo', { email: user.contact_email, name: user.contact_name, phone: user.contact_phone });
            }
        },

        get({ commit, getters }, { id, filters, return_only } = {}) {
            return new Promise((resolve, reject) => {
                let ids;
                let getData;
                if (id) {
                    ids = Array.isArray(id) ? id.join(',') : id;
                }

                if (!ids) {
                    if (filters) {
                        getData = { ...filters };
                    }
                    const pagination = getters.pagination(!!filters);
                    getData = { ...getData, ...pagination };
                }
                api.get({
                    name: `get_products${ids ? `_${ids}` : ''}`,
                    endpoint: `products/${ids ? `${ids}/` : ''}`,
                    data: getData || {},
                    loading: true,
                }).then((r) => {
                    if (r.data && r.data.results) {
                        if (ids || return_only) {
                            resolve(r.data.results.items || []);
                        } else {
                            commit('storeProducts', {
                                items: r.data.results.items || [],
                                filtered: !!filters,
                            });
                        }
                    }
                    resolve();
                }).catch((err) => {
                    reject(err);
                });
            });
        },

        loadMore({ commit, dispatch, state }) {
            const keySuffix = state.products.isFiltered ? '_filtered' : '';
            commit('bumpStart');
            if (!state.products.pagination[`atBottom${keySuffix}`]) {
                dispatch('get', state.products.isFiltered ? { filters: state.filters } : undefined);
            }
        },

        getFilters({ commit }) {
            return new Promise((resolve, reject) => {
                api.get({
                    name: 'get_filters',
                    endpoint: 'filters/',
                    loading: true,
                }).then((r) => {
                    if (r.data && r.data.status === 'success') {
                        commit('storeFilters', r.data.results);
                    }
                    resolve(r.data.results);
                }).catch((err) => {
                    reject(err);
                });
            });
        },

        restoreCart({ commit }) {
            if (localStorage.getItem('cart')) {
                const cart = JSON.parse(localStorage.getItem('cart'));
                if (cart && cart.items) {
                    const productIds = cart.items.map(it => it.product.id);
                    if (productIds.length < 1) { return false; }

                    // Get new product info
                    api.get({
                        name: 'get_productinfo',
                        endpoint: `products/${productIds.join(',')}`,
                    }).then((r) => {
                        const newCart = [];
                        if (r.data.results && r.data.results.items && r.data.results.items.length) {
                            for (let i = 0, len = r.data.results.items.length; i < len; i += 1) {
                                const item = r.data.results.items[i];

                                // Find qty
                                const qty = cart.items.find(it => it.product.id === item.id);
                                if (qty) {
                                    newCart.push({
                                        amount: qty.amount,
                                        product: item,
                                    });
                                }
                            }
                            commit('restoreCart', { items: newCart });
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            }
            return true;
        },

        order({ commit, state, rootGetters }) {
            return new Promise((resolve, reject) => {
                const items = rootGetters['Products/cart'];
                if (items.length) {
                    const data = { ...state.checkout, products: items };
                    // if (!rootGetters['Auth/isAuthenticated']) { data.client = state.checkout.client; }
                    api.post({
                        name: 'place_order',
                        endpoint: 'order/',
                        data,
                        loading: true,
                    }).then((r) => {
                        resolve(r);
                        commit('clearCart');
                    }).catch((err) => {
                        reject(err);
                    });
                }
            });
        },
    },
};
